export interface IWildlifeManagementThirdSection {
    IsMemberOfWildlifePropertyAssociation?: boolean;
    NameOfWildlifePropertyCoOpAssociation?: string;
}

export const WildlifeManagementThirdSectionInterface = (): IWildlifeManagementThirdSection => ({
    IsMemberOfWildlifePropertyAssociation: undefined,
    NameOfWildlifePropertyCoOpAssociation: undefined,
})
